import {useState, useEffect} from "react";
import {useConfigure} from "react-instantsearch";
import {useConfigContext} from "@/ConfigProvider";

export function FundingCampaignFilter() {
    const {algoliaConfig: {fundingBaseShopFilter, initialFundingCampaign}} = useConfigContext();
    const [activeCampaign, setActiveCampaign] = useState<string>(initialFundingCampaign ?? '');

    useEffect(() => {
        const handler = (e: Event) => {
            setActiveCampaign((e as CustomEvent<{campaign: string}>).detail.campaign);
        };
        document.addEventListener('fundingCampaignChange', handler);
        return () => document.removeEventListener('fundingCampaignChange', handler);
    }, []);

    const currentFilter = activeCampaign
        ? `${fundingBaseShopFilter ? fundingBaseShopFilter + ' AND ' : ''}fundingCampaigns:"${activeCampaign.replace(/"/g, '\\"')}"`
        : (fundingBaseShopFilter ?? undefined);

    useConfigure({filters: currentFilter});

    return null;
}
